import { Breadcrumb as UiBreadcrumb } from "../ui/breadcrumb";

type Props = {
  data: { label: string; to?: string }[];
};

/**
 * PageLayout breadcrumb adapter — delegates to the shared
 * `ui/Breadcrumb` so PageLayout-based pages get the same refined
 * editorial trail (chevron separator, hover color shift, current-page
 * dot indicator) as the order-create flow.
 *
 * Maps the legacy `{ to, label }` shape to the ui primitive's
 * `{ path, label }` shape.
 */
export function Breadcrumb({ data }: Props) {
  return <UiBreadcrumb items={data.map((d) => ({ label: d.label, path: d.to }))} />;
}
